import { TVVBestelStatus } from "@/entities/tvv";
import { useId } from "react";

function InBehandeling() {
    return (
        <path
            d="M17 10C20.8587 10 24 13.1413 24 17C24 20.8587 20.8587 24 17 24C13.1413 24 10 20.8587 10 17C10 13.1413 13.1413 10 17 10ZM17 12.5547C16.5187 12.5547 16.125 12.9484 16.125 13.4297V17.3672L18.1641 19.4062C18.339 19.5723 18.5578 19.6602 18.7852 19.6602C19.0125 19.6601 19.2313 19.5811 19.4062 19.4062C19.7475 19.065 19.7475 18.5131 19.4062 18.1719L17.875 16.6406V13.4297C17.875 12.9484 17.4812 12.5547 17 12.5547Z"
            className="text-content-info"
            fill="currentColor"
        />
    );
}

function StopAangevraagd() {
    return (
        <path
            d="M17 10C20.8587 10 24 13.1413 24 17C24 20.8587 20.8587 24 17 24C13.1413 24 10 20.8587 10 17C10 13.1413 13.1413 10 17 10ZM17 12.5547C16.5187 12.5547 16.125 12.9484 16.125 13.4297V17.3672L18.1641 19.4062C18.339 19.5723 18.5578 19.6602 18.7852 19.6602C19.0125 19.6601 19.2313 19.5811 19.4062 19.4062C19.7475 19.065 19.7475 18.5131 19.4062 18.1719L17.875 16.6406V13.4297C17.875 12.9484 17.4812 12.5547 17 12.5547Z"
            className="text-accent-orange-default"
            fill="currentColor"
        />
    );
}

function Actief() {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 17C10 13.13 13.13 10 17 10C20.87 10 24 13.13 24 17C24 20.87 20.87 24 17 24C13.13 24 10 20.87 10 17ZM16.13 20.2L20.55 15.39H20.56C20.84 15.08 20.82 14.61 20.51 14.33C20.2 14.05 19.73 14.07 19.45 14.38L16.09 18.04L14.53 16.48C14.24 16.19 13.76 16.19 13.47 16.48C13.18 16.77 13.18 17.25 13.47 17.54L16.13 20.2Z"
            className="text-content-success"
            fill="currentColor"
        />
    );
}

function Gestopt() {
    return (
        <path
            d="M17 10C20.8598 10.0001 23.9999 13.1402 24 17C24 20.8599 20.8599 23.9999 17 24C13.14 24 10 20.86 10 17C10.0001 13.1401 13.1401 10 17 10ZM13.5 16C13.2239 16 13 16.2239 13 16.5V17.5C13 17.7761 13.2239 18 13.5 18H20.5C20.7761 18 21 17.7761 21 17.5V16.5C21 16.2239 20.7761 16 20.5 16H13.5Z"
            className="text-chart-neutral"
            fill="currentColor"
        />
    );
}

function Nieuw() {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            className="text-content-emphasis"
            fill="currentColor"
        >
            <g opacity="0.5">
                <path d="M11.5 4C11.2239 4 11 4.22386 11 4.5C11 4.77614 11.2239 5 11.5 5H16.5C16.7761 5 17 4.77614 17 4.5C17 4.22386 16.7761 4 16.5 4H11.5Z" />
                <path d="M9.5 4C9.22386 4 9 4.22386 9 4.5C9 4.77614 9.22386 5 9.5 5C9.77614 5 10 4.77614 10 4.5C10 4.22386 9.77614 4 9.5 4Z" />
                <path d="M9 17C9.55228 17 10 16.5523 10 16C10 15.4477 9.55228 15 9 15C8.44771 15 8 15.4477 8 16C8 16.5523 8.44771 17 9 17Z" />
                <path d="M17 17C17.5523 17 18 16.5523 18 16C18 15.4477 17.5523 15 17 15C16.4477 15 16 15.4477 16 16C16 16.5523 16.4477 17 17 17Z" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 18.5C21 19.3284 20.3284 20 19.5 20H19V21.5C19 21.7761 18.7761 22 18.5 22H15.5C15.2239 22 15 21.7761 15 21.5V20H11V21.5C11 21.7761 10.7761 22 10.5 22H7.5C7.22386 22 7 21.7761 7 21.5V20H6.5C5.67157 20 5 19.3284 5 18.5V3.5C5 2.67157 5.67157 2 6.5 2H19.5C20.3284 2 21 2.67157 21 3.5V18.5ZM7 6.5C7 6.77614 7.22386 7 7.5 7H20V18.5C20 18.7761 19.7761 19 19.5 19H6.5C6.22386 19 6 18.7761 6 18.5V13H18.5C18.7761 13 19 12.7761 19 12.5C19 12.2239 18.7761 12 18.5 12H6V3.5C6 3.22386 6.22386 3 6.5 3H19.5C19.7761 3 20 3.22386 20 3.5V6H7.5C7.22386 6 7 6.22386 7 6.5ZM16 21V20H18V21H16ZM8 20V21H10V20H8Z"
                />
                <path d="M4 5.5C4 5.22386 3.77614 5 3.5 5C3.22386 5 3 5.22386 3 5.5V8.5C3 8.77614 3.22386 9 3.5 9C3.77614 9 4 8.77614 4 8.5L4 5.5Z" />
            </g>
        </svg>
    );
}

type TvvStatusProps = {
    variant: TVVBestelStatus;
};

export function TvvStatus({ variant }: TvvStatusProps) {
    const maskId = useId();
    if (variant === TVVBestelStatus.Aangevraagd) {
        return <Nieuw />;
    }

    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id={maskId} style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <path d="M24 0H0V24H9V12L12 9H24V0Z" fill="#D9D9D9" />
            </mask>
            <g mask={`url(#${maskId})`}>
                <path
                    d="M11.5 4C11.2239 4 11 4.22386 11 4.5C11 4.77614 11.2239 5 11.5 5H16.5C16.7761 5 17 4.77614 17 4.5C17 4.22386 16.7761 4 16.5 4H11.5Z"
                    className="text-content-emphasis"
                    fill="currentColor"
                />
                <path
                    d="M9.5 4C9.22386 4 9 4.22386 9 4.5C9 4.77614 9.22386 5 9.5 5C9.77614 5 10 4.77614 10 4.5C10 4.22386 9.77614 4 9.5 4Z"
                    fill="currentColor"
                />
                <path
                    d="M9 17C9.55228 17 10 16.5523 10 16C10 15.4477 9.55228 15 9 15C8.44771 15 8 15.4477 8 16C8 16.5523 8.44771 17 9 17Z"
                    className="text-content-emphasis"
                    fill="currentColor"
                />
                <path
                    d="M17 17C17.5523 17 18 16.5523 18 16C18 15.4477 17.5523 15 17 15C16.4477 15 16 15.4477 16 16C16 16.5523 16.4477 17 17 17Z"
                    className="text-content-emphasis"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 18.5C21 19.3284 20.3284 20 19.5 20H19V21.5C19 21.7761 18.7761 22 18.5 22H15.5C15.2239 22 15 21.7761 15 21.5V20H11V21.5C11 21.7761 10.7761 22 10.5 22H7.5C7.22386 22 7 21.7761 7 21.5V20H6.5C5.67157 20 5 19.3284 5 18.5V3.5C5 2.67157 5.67157 2 6.5 2H19.5C20.3284 2 21 2.67157 21 3.5V18.5ZM7 6.5C7 6.77614 7.22386 7 7.5 7H20V18.5C20 18.7761 19.7761 19 19.5 19H6.5C6.22386 19 6 18.7761 6 18.5V13H18.5C18.7761 13 19 12.7761 19 12.5C19 12.2239 18.7761 12 18.5 12H6V3.5C6 3.22386 6.22386 3 6.5 3H19.5C19.7761 3 20 3.22386 20 3.5V6H7.5C7.22386 6 7 6.22386 7 6.5ZM16 21V20H18V21H16ZM8 20V21H10V20H8Z"
                    className="text-content-emphasis"
                    fill="currentColor"
                />
                <path
                    d="M4 5.5C4 5.22386 3.77614 5 3.5 5C3.22386 5 3 5.22386 3 5.5V8.5C3 8.77614 3.22386 9 3.5 9C3.77614 9 4 8.77614 4 8.5L4 5.5Z"
                    className="text-content-emphasis"
                    fill="currentColor"
                />
            </g>
            {variant === TVVBestelStatus.Gedeeltelijk && <InBehandeling />}
            {variant === TVVBestelStatus.StopAangevraagd && <StopAangevraagd />}
            {variant === TVVBestelStatus.Volledig && <Actief />}
            {variant === TVVBestelStatus.Gestopt && <Gestopt />}
        </svg>
    );
}
